import React from 'react';
import { Search, X } from 'lucide-react';
import type { HeaderFilter } from '../../../contexts/DynamicHeaderContext';

interface FilterSearchProps {
  filter: HeaderFilter;
}

export function FilterSearch({ filter }: FilterSearchProps) {
  return (
    <div className="relative flex items-center min-w-[160px]">
      <Search className="absolute left-2 h-3.5 w-3.5 text-muted-foreground pointer-events-none" />
      <input
        type="text"
        value={filter.value || ''}
        onChange={(e) => filter.onChange(e.target.value)}
        placeholder={filter.placeholder || filter.label}
        className="pl-7 pr-6 h-7 text-xs rounded-md bg-black/5 dark:bg-white/5 border-0 text-foreground placeholder-muted-foreground focus:outline-none focus:bg-black/[0.08] dark:focus:bg-white/10 transition-colors w-full"
      />
      {filter.value && (
        <button
          onClick={() => filter.onChange('')}
          className="absolute right-1.5 text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
}
